import { useQuery } from '../useQuery';
import { getSchedules } from '@dispatch/shared/services';

export const useGetSchedules = ({ resourceId }: { resourceId: string }) => {
  return useQuery(['get-resource-schedules', resourceId], () =>
    getSchedules(resourceId)
  );
};
